// extracted by mini-css-extract-plugin
export default {"image":"ChallengeDetailHelpImage_image__a+N+O"};